import { Definition } from '../../data/Definition';
import { IDwFilter, DwQuery } from '../../data/Query';
import { ChartConfigManager } from './ChartConfigManager';
import QueryProvider from './QueryProvider';

export abstract class ChartProvider extends QueryProvider {
    name: string;

    constructor(name: string) {
        super();
        this.name = name;
    }

    getQuery(definition: Definition, chartConfig: any): null | DwQuery {
        console.log('getQuery', chartConfig);
        return super.getQuery(definition, chartConfig);
    }

    abstract getConfigForm(definition: Definition, chartConfig: any, onSaveConfig: any): any;
    abstract getPlotly(definition: Definition, chartConfig: any, data: any): any;
    abstract filterFromSelection(definition: Definition, chartConfig: any, selection: any) : IDwFilter[] | null;
    abstract configManager(definition: Definition) : ChartConfigManager;
}
